import Api from '@/api/api'

export default {
    getPackage() {
        return Api.get('SaasAdmin/Package/GetPackages')
    },
    getPackageById(id) {
        return Api.get('SaasAdmin/Package/GetPackageById?id=' + id)
    },
    addPackage(data) {
        return Api.post('SaasAdmin/Package/AddPackage', data)
    },
    updatePackage(id, data) {
        return Api.put('SaasAdmin/Package/UpdatePackage?id=' + id, data)
    },
    removePackage(id) {
        return Api.delete('SaasAdmin/Package/DeletePackage?id=' + id)
    },
    getModule() {
        return Api.get('SaasAdmin/Module/GetModules')
    },
}